import React from "react"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid } from "@mui/material"

export default function ClientDetailsModal({ open, onClose, client }) {
  if (!client) return null

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Détails du client</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Nom complet</Typography>
            <Typography variant="body1">{client.fullName}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Téléphone</Typography>
            <Typography variant="body1">{client.phoneNumber}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Email</Typography>
            <Typography variant="body1">{client.email || "-"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">État</Typography>
            <Typography variant="body1">{client.state || "-"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Ville</Typography>
            <Typography variant="body1">{client.city || "-"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Adresse</Typography>
            <Typography variant="body1">{client.address || "-"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Code postal</Typography>
            <Typography variant="body1">{client.postalCode || "-"}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Notes</Typography>
            <Typography variant="body1">{client.notes || "-"}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  )
}
